import React, { useState } from "react";

import { linkedInImage, twitterImage, mailImage, myImage, myImage1 } from "./Images";
import About from "./About";
import ContactMe from "./Contact";

const introData = {
    "title": "Hi 👋, I'm Karthik Reddy",
    "subText": "I thrive on innovation, implementation, and delivering solutions.",
    "subtitle": ["Fullstack Engineer","Gen AI", "Shopify App Developer","E-commerce","Headless ECommerce", "Data Engineer", "Solution Architect", "Software Architect", "Tech Lead", "Product Manager", "Youtuber","Writer"].join('<i class="fa fa-circle"></i>'),
    "desription": ["Node.js","Python","Open AI","Shopify","Docker", "MySQL","PostgreSQL", "MongoDB","Next.js","Remix","MEAN", "MERN", "Gatsby", "Contentful","Strapi", "NGINX", "Chatbot", "Voicebot"
        ,"Dialogflow CX", "Alexa", "Google Assistant","Flask", "Django", "API Gateway","GCP", "AWS", "Azure", "Date Engineering", "ML", "NLP","Cognitive services","Tutorial Videos","Poetry","Story writting"].join("<span class='pipe'>|</span>")
}

const Home = ({ theme }) => {
    return (
        <div className={theme}>
            <div className={`introDiv`}>
                <div className="leftDiv">
                    <span className="title">{introData.title}</span>
                    <span className="subtitle subText" dangerouslySetInnerHTML={{ __html: introData.subText }} />
                    <span className="subtitle" dangerouslySetInnerHTML={{ __html: introData.subtitle }} />
                    <span className="desription" dangerouslySetInnerHTML={{ __html: introData.desription }} />
                </div>
                <div className="rightDiv">
                    <div className="imageDiv">
                        <img src={myImage1} />
                    </div>
                </div>
            </div>
            <About/>
            <ContactMe/>
        </div>
    )
}

export default Home;